import { validate } from "email-validator";
import {
  FormEvent,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from "react";
import { validatePhone } from "validations-br";
import { ComponentState } from "../../../../data/enums/ComponentState";
import { FormContext } from "../../../context/contact/contact-context";
import { Checkbox } from "../../checkbox/checkbox";
import { InputPhone } from "../../input-phone/input-phone";
import { Input } from "../../input/input";
import { Wrapper } from "../wrapper/wrapper";
import { ContactData, ContactProps } from "./contact-props";
import * as S from "./contact-style";

export function Contact({
  id,
  sendContact,
  ...props
}: ContactProps): ReactElement {
  const [data, setData] = useState<ContactData>({
    name: "",
    accepted: false,
    email: "",
    whatsapp: "",
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [state, setState] = useState<ComponentState>(ComponentState.READY);
  const handleSubmit = useCallback(
    (evt: FormEvent) => {
      evt.preventDefault();
      void (async () => {
        await sendContact.handle(data);
      })();
    },
    [data, sendContact],
  );
  useEffect(() => {
    setErrors({});
    setState(ComponentState.READY);
    if (data.name.length <= 5) {
      setErrors((errors) => ({ ...errors, name: "O nome é inválido" }));
      setState(ComponentState.ERROR);
    }
    if (!validate(data.email)) {
      setErrors((errors) => ({ ...errors, email: "O email é inválido" }));
      setState(ComponentState.ERROR);
    }
    if (!validatePhone(data.whatsapp)) {
      setErrors((errors) => ({ ...errors, whatsapp: "O whatsapp é inválido" }));
      setState(ComponentState.ERROR);
    }
  }, [data]);
  return (
    <S.Container id={id}>
      <Wrapper>
        <S.ContainerWrapper>
          <S.TitleContainer>
            <S.Title>
              Peça agora o seu Cartão de TODOS e agende a sua consulta médica em
              nossa clinica parceira.
            </S.Title>
          </S.TitleContainer>
          <FormContext.Provider value={{ errors, state, content: data }}>
            <S.Form id="formulario" onSubmit={handleSubmit}>
              <Input
                label="Nome:"
                id="name"
                placeholder="Digite seu nome"
                value={data.name}
                onChange={(evt) =>
                  setData((data) => ({ ...data, name: evt.target.value }))
                }
              />
              <Input
                label="E-mail:"
                id="email"
                placeholder="Digite seu e-mail"
                value={data.email}
                onChange={(evt) =>
                  setData((data) => ({ ...data, email: evt.target.value }))
                }
              />
              <InputPhone
                label="Whatsapp:"
                id="whatsapp"
                placeholder="Digite seu numero whatsapp"
                value={data.whatsapp}
                onChange={(evt) =>
                  setData((data) => ({ ...data, whatsapp: evt.target.value }))
                }
              />
              <Checkbox
                label="Eu aceito notificações via SMS ou e-mail"
                id="accepted"
                value={data.accepted}
                onChange={(evt) =>
                  setData((data) => ({ ...data, accepted: evt.target.checked }))
                }
              />
              <S.Button type="submit">Solicitar agora</S.Button>
            </S.Form>
          </FormContext.Provider>
        </S.ContainerWrapper>
      </Wrapper>
    </S.Container>
  );
}
